"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1420],{

/***/ 7277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5861);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1548);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3873);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);








function AppSlider(param) {
    let { list , title , directionLTR , width , numbers , titleMargin , sliderPad , pointer , marquee  } = param;
    const settings = {
        infinite: Boolean(marquee),
        speed: marquee ? 4000 : 1500,
        slidesToShow: numbers ? numbers : 5,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: marquee ? 0 : 2000,
        centerMode: false,
        arrows: false,
        easing: marquee ? "linear" : "ease",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        sx: {
            padding: sliderPad ? sliderPad : "0"
        },
        className: "container",
        children: [
            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                style: {
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px 0",
                    margin: titleMargin ? titleMargin : "auto"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: {
                            background: "white",
                            padding: "0 8px",
                            zIndex: 1,
                            fontWeight: "bold",
                            fontSize: {
                                xs: "24px",
                                md: "32px"
                            }
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        style: {
                            position: "absolute",
                            height: 1,
                            width: "100%",
                            background: "lightgray",
                            top: "calc(50% + 0.5px)",
                            zIndex: 0
                        }
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                style: {
                    padding: "8px 0",
                    transform: directionLTR ? "rotate(180deg)" : "rotate(0deg)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ...settings,
                    children: list.map((m, i)=>{
                        var ref;
                        const frameWidth = width ? width : 140;
                        const frameHeight = 140;
                        const img = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                            width: frameWidth,
                            height: frameHeight,
                            src: m.icon,
                            alt: m.name,
                            style: {
                                width: "100%",
                                height: "100%",
                                border: "none",
                                outline: "none",
                                transform: directionLTR ? "rotate(180deg)" : "rotate(0deg)",
                                objectFit: "contain",
                                cursor: pointer ? "pointer" : "normal"
                            },
                            className: "app-slider-img",
                            loading: "lazy"
                        });
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    width: frameWidth,
                                    height: frameHeight,
                                    margin: "0 auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "10px",
                                    boxSizing: "border-box"
                                },
                                children: (m === null || m === void 0 ? void 0 : (ref = m.redirectLink) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                    href: m.redirectLink,
                                    rel: "preload",
                                    children: img
                                }) : img
                            })
                        }, i);
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppSlider);


/***/ }),

/***/ 4241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6886);
/* harmony import */ var _AppSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7277);
/* harmony import */ var _data_StaticList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4485);





function Press() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        sx: {
            padding: {
                xs: "40px 0 20px 0",
                md: "80px 0"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppSlider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            list: _data_StaticList__WEBPACK_IMPORTED_MODULE_3__/* .MEDIA_LIST */ .Aq,
            title: "In the press",
            width: 240,
            pointer: true,
            marquee: true
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Press);


/***/ })

}]);